// 报刊亭
// 商品列表
import goodList from '@/api/modules/newsKiosk/list'

// 服务台
// 用户中心
import * as userCentered from '@/api/modules/reception/userCentered'
import * as userComplaints from '@/api/modules/reception/userComplaints'

// 用户权限
import * as user from './modules/user'

let api = {
  goodList,
  user,
  userCentered,
  userComplaints
}

export default api
